import { ODataMap, ODataObjectMap } from '../types';
import { generateGraphQlQuery, generateGraphQlSchema } from '../utils';

const ExtendedTextLineMap = {
  tableName: {
    bcKey: 'Table_Name',
    type: 'string',
    required: false,
  },
  no: {
    bcKey: 'No',
    type: 'string',
    required: false,
  },
  languageCode: {
    bcKey: 'Language_Code',
    type: 'string',
    required: false,
  },
  textNo: {
    bcKey: 'Text_No',
    type: 'number',
    required: false,
  },
  lineNo: {
    bcKey: 'Line_No',
    type: 'number',
    required: false,
  },
  text: {
    bcKey: 'Text',
    type: 'string',
    required: false,
  },
} as const satisfies ODataMap;

type ExtendedTextLine = ODataObjectMap<typeof ExtendedTextLineMap>;

const ExtendedTextLineSchema = generateGraphQlSchema('ExtendedTextLine', ExtendedTextLineMap);

const ExtendedTextLineQuery = generateGraphQlQuery('ExtendedTextLine', ExtendedTextLineMap);

export { 
  ExtendedTextLineSchema, 
  type ExtendedTextLine, 
  ExtendedTextLineQuery, 
  ExtendedTextLineMap 
}; 